import styled from 'styled-components';

const TabWrapper = styled.div<{ full?: boolean }>`
  height: ${({ full }) => (full ? '100%' : 'calc(100% - 52px)')};
  ${props => props.theme.breakpoints.up('md')} {
    height: ${({ full }) => (full ? '100%' : 'calc(100% - 96px)')};
  }
`;

export default TabWrapper;
